import { render, staticRenderFns } from "./ClmReserveCategory.vue?vue&type=template&id=0c62e6f5&"
import script from "./ClmReserveCategory.vue?vue&type=script&lang=js&"
export * from "./ClmReserveCategory.vue?vue&type=script&lang=js&"
import style0 from "./ClmReserveCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClmReserveCategory.vue"
export default component.exports